import { Tabs } from "shared/components/Tabs";
import { useLocation, useNavigate } from "react-router-dom";
import { useMemo } from "react";

const SCREENING_TABS_CONFIG = {
  tabs: ["screening-templates", "discounts"],
  displayMap: {
    "screening-templates": "Screening templates",
    discounts: "Discount codes"
  },
  routes: {
    "screening-templates": "/verification-templates",
    discounts: "/discounts"
  }
};

export const ScreeningTabs = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleTabChange = (tab: string) => {
    const route = SCREENING_TABS_CONFIG.routes[tab];
    if (route) navigate(route);
  };

  const isDiscounts = pathname.includes("/discounts");
  const isScreeningTemplates = pathname.includes("/verification-templates");

  const selected = useMemo(() => {
    if (isDiscounts) return "discounts";

    return "screening-templates";
  }, [isDiscounts, isScreeningTemplates]);

  return (
    <Tabs
      tabs={SCREENING_TABS_CONFIG.tabs}
      selected={selected}
      setActiveTab={handleTabChange}
      displayMap={SCREENING_TABS_CONFIG.displayMap}
      variant="underline"
    />
  );
};
